
























































import {Component, Vue, Prop} from 'vue-property-decorator';
import Building from '@/data/models/building';
import {nonEmpty, requiredRule} from '@/helpers/rules-validator';
import dayjs from "dayjs";

@Component({})
export default class IdentityForm extends Vue {

  @Prop({required: true})
  buildingForm: Building;

  date: string = dayjs().toISOString();
  menu: boolean = false;

  get requiredRule(): any[] {
    return requiredRule(this.$t('rules.required.empty').toString());
  }

  get nonEmptyRule(): any[] {
    return nonEmpty(this.$t('rules.required.empty').toString());
  }

  setDate(date: string): void {
    this.menu = false;
    this.buildingForm.datePickerToBuildDate(date);
  }
}
